import React, { createContext, useEffect, useState } from 'react';

const AppContext = createContext();

export const AuthProvider = ({ children }) => {
    const [user, setUser] = useState(() => {
        const savedUser = localStorage.getItem('userData');
        return savedUser ? JSON.parse(savedUser) : null;
    });

    const login = (userData) => {
        console.log(userData, "userData");
        setUser(userData);
        localStorage.setItem('userData', JSON.stringify(userData));
    };

    const logout = () => {
        setUser(null);
        localStorage.removeItem('userData');
    };

    useEffect(() => {
        const savedUser = localStorage.getItem('userData');
        if (savedUser) {
            setUser(JSON.parse(savedUser));
        }
    }, []);
    return (
        <AppContext.Provider value={{ user, login, logout }}>
            {children}
        </AppContext.Provider>
    );
};

export default AppContext;  